/*
LineAnaPage.js
曲线分析页面
 */
import React, { useState } from "react";
import { Drawer, Button, Steps, Flex, Result } from "antd";
import { CloseOutlined } from "@ant-design/icons";

import DraggerPage from "./DraggerPage";
import DecodePage from "./DecodePage";
import AnaPage from "./AnaPage";

const LineAnaPage = ({ LineAnaPageShow = false, onClose, isMobile }) => {
    // 当前的步骤
    const [currentStep, setCurrentStep] = useState(0);
    // 文件
    const [file, setFile] = useState(null);
    // 文件名(去掉后缀名)，作为导出文件名称使用
    const [fileName, setFileName] = useState('');
    // 解析结果，请求字段
    const [decodeResult, setDecodeResult] = useState({
        x_label: '',
        y1_label: '',
        y2_label: '',
        x_data: [],
        y1_data: [],
        y2_data: [],
        time_interval: 1,
    });
    // 是否展示页面
    const [showPage, setShowPage] = useState(isMobile ? false : true);

    // 步骤加一
    const handleCurrentStepAdd = () => {
        setCurrentStep(currentStep + 1);
    }

    // 步骤减一
    const handleCurrentStepMinus = () => {
        setCurrentStep(currentStep - 1);
    }

    // 返回第一步
    const handleCurrentStepReset = () => {
        setCurrentStep(0);
    }

    return (
        <Drawer title='曲线分析' placement='left' width={isMobile ? '100%' : '85%'} open={LineAnaPageShow}
            closeIcon={null}
            extra={<Button type='text' icon={<CloseOutlined style={{ color: '#808080' }} />} size='large'
                onClick={onClose} />}>
            {showPage && <Flex justify='flex-start' align='center' vertical='true' style={{ height: '100%', width: '100%' }}>
                <Steps
                    current={currentStep}
                    items={[
                        { title: '上传文件', },
                        { title: '解析文件', },
                        { title: '分析数据', },
                    ]}
                    style={{ marginTop: 30 }}
                />
                <Flex justify='center' align='center' style={{ marginTop: 40, flex: 1, width: '80%' }}>
                    {currentStep === 0 && <DraggerPage handleCurrentStepAdd={handleCurrentStepAdd} setFile={setFile} setFileName={setFileName}/>}
                    {currentStep === 1 && <DecodePage handleCurrentStepMinus={handleCurrentStepMinus}
                        handleCurrentStepAdd={handleCurrentStepAdd} file={file} setDecodeResult={setDecodeResult} />}
                    {currentStep === 2 && <AnaPage decodeResult={decodeResult} handleCurrentStepReset={handleCurrentStepReset} fileName={fileName} />}
                </Flex>
            </Flex>}
            {isMobile && !showPage && <Result
                status="warning"
                title="提示"
                subTitle="检测到您正在使用移动端设备访问，为了获得更好的体验，请使用电脑或平板进行访问。"
                extra={[
                    <Button key="back" onClick={onClose}>
                        返回
                    </Button>,
                    <Button type="primary" key="console" onClick={() => { setShowPage(true) }}>
                        继续访问
                    </Button>
                ]}
            />}
        </Drawer>
    );
}

export default LineAnaPage;
